import { PROVIDER_API, USE_MOCK_AUTH } from "../config/api";
import { apiRequest, unwrapApiEnvelope } from "./apiClient";

const EMPTY_LIST = {
  entries: [],
  pagination: { total: 0, current_page: 1, last_page: 1, per_page: 25 },
};

const EMPTY_FILTERS = {
  institutions: [],
  actors: [],
  event_types: [],
  modules: [],
  portals: [],
  actor_types: [],
};

const EMPTY_SUMMARY = { total: 0, by_event_type: [], by_day: [], top_actors: [] };

function buildAuditQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") return;
    query.set(key, String(value));
  });
  return query;
}

function normalizeAuditList(payload) {
  const entries = Array.isArray(payload?.entries) ? payload.entries : [];
  return {
    entries,
    pagination: payload?.pagination || EMPTY_LIST.pagination,
  };
}

export async function fetchProviderActivityLogs(token, params = {}) {
  if (USE_MOCK_AUTH || !token) return EMPTY_LIST;

  const query = buildAuditQuery({
    page: params.page || 1,
    limit: params.limit || 25,
    date_from: params.date_from,
    date_to: params.date_to,
  });

  const json = await apiRequest(`${PROVIDER_API.activityLogs}?${query}`, {
    method: "GET",
    token,
  });
  return normalizeAuditList(unwrapApiEnvelope(json));
}

export async function fetchProviderAuditFilters(token) {
  if (USE_MOCK_AUTH || !token) return EMPTY_FILTERS;
  const json = await apiRequest(PROVIDER_API.activityLogsFilters, {
    method: "GET",
    token,
  });
  return unwrapApiEnvelope(json) || EMPTY_FILTERS;
}

export async function fetchProviderActivityLogsSummary(token) {
  if (USE_MOCK_AUTH || !token) return EMPTY_SUMMARY;

  const json = await apiRequest(PROVIDER_API.activityLogsSummary, {
    method: "GET",
    token,
  });
  return unwrapApiEnvelope(json) || EMPTY_SUMMARY;
}

/**
 * GET /api/provs/activity-logs/sla
 */
export async function fetchProviderSlaPerformance(token, params = {}) {
  if (USE_MOCK_AUTH || !token) {
    return {
      summary: {
        total_cases: 0,
        assigned: 0,
        contacted: 0,
        payment_initiated: 0,
        payment_completed: 0,
        avg_upload_to_assign_minutes: null,
        avg_assign_to_contact_minutes: null,
        avg_upload_to_payment_minutes: null,
        avg_upload_to_payment_completed_minutes: null,
      },
      by_agent: [],
      by_group: [],
      cases: [],
    };
  }

  const query = new URLSearchParams();
  if (params.portfolio_group_slug) query.set("portfolio_group_slug", params.portfolio_group_slug);
  if (params.agent_slug) query.set("agent_slug", params.agent_slug);
  const suffix = query.toString() ? `?${query}` : "";
  const json = await apiRequest(`${PROVIDER_API.activityLogsSla}${suffix}`, {
    method: "GET",
    token,
  });
  return unwrapApiEnvelope(json) || { summary: {}, by_agent: [], by_group: [], cases: [] };
}
